import {Component, Input} from '@angular/core';
import {Client} from '../client';

@Component({
    selector: 'zah-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.scss'],
    standalone: false
})
export class ClientComponent {

  @Input()
  client: Client;
}
